/** @format */

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { signUserSelectors, overlaySelectors } from 'services/globalSelectors'
import { clear, sidebar } from 'services/overlay/actions'
import { useOnClickOutside } from 'hooks'

import { Loader } from './components'
import { Unauthorized, Authorized } from './apps'
import { Quiz } from './views'
import { questions } from './views/Quiz/data'

export const App = () => {
  const dispatch = useDispatch()

  const isAuth = useSelector(signUserSelectors.isAuth)
  const isLoading = useSelector(overlaySelectors.isLoading)
  const isOpenSidebar = useSelector(overlaySelectors.isOpenSidebar)
  const errorMessage = useSelector(overlaySelectors.errorMessage)
  const [size, updateSize] = useState({ target: { innerWidth: '' } })

  const handleUpdateSize = (event) => updateSize(event)

  useOnClickOutside()

  useEffect(() => {
    if (errorMessage) setTimeout(() => dispatch(clear.errorMessages()), 3000)
  }, [dispatch, errorMessage])

  useEffect(() => {
    window.addEventListener('resize', handleUpdateSize)
  }, [])

  useEffect(() => {
    if (size.target.innerWidth) {
      if (size.target.innerWidth < 900 && isOpenSidebar) dispatch(sidebar.setStatusFalse())
      if (size.target.innerWidth >= 900 && !isOpenSidebar) dispatch(sidebar.setStatusTrue())
    }
  }, [size.target.innerWidth, dispatch, isOpenSidebar])

  // if (true) {
  //   return <Quiz questions={questions} />
  // }

  return (
    <>
      {isAuth ? <Authorized /> : <Unauthorized />}
      {isLoading && <Loader />}
    </>
  )
}
